import uniq from 'lodash/uniq';

import {
  RETAILER_PRODUCTS,
  RETAILER_PRODUCTS_SEARCH,
  RETAILER_PRODUCTS_ORDER,
  RETAILER_PRODUCTS_OFFSET,
  RETAILER_PRODUCTS_COUNT,
  RETAILER_PRODUCTS_CHECK,
  RETAILER_PRODUCTS_UNCHECK,
  RETAILER_PRODUCTS_UNCHECK_ALL,
  RETAILER_PRODUCTS_APPROVE,
  RETAILER_PRODUCTS_UNAPPROVE,
  RETAILER_PRODUCTS_DETAILS,
  RETAILER_PRODUCTS_CHECK_ALL_ON_PAGE,
  RETAILER_PRODUCTS_ALL,
  RETAILER_PRODUCTS_APPROVED,
  RETAILER_PRODUCTS_MODAL_OPEN,
  RETAILER_PRODUCTS_MODAL_CLOSE,
  RETAILER_PRODUCTS_PRODUCT,
  RETAILER_PRODUCTS_LOADING,
  RETAILER_PRODUCTS_LOADING_PRODUCTS,
  RESET_ALL_FILTERS,
} from '../constants/retailerProductsTypes';
import { PERMISSIONS_TAB } from '../constants/permissionsTypes';
import { PRODUCT_FILTERS_SET_FILTERS } from '../constants/productFiltersTypes';

const initialState = {
  data: [],
  offset: 0,
  count: 0,
  perPage: 20,
  search: '',
  order: 'asc',
  orderBy: 'title',
  checked: {},
  variants: [],
  approved: [],
  unapproved: [],
  productDetails: {},
  modal: false,
  product: {},
  isLoading: false,
  isLoadingProducts: false,
};

const retailerProducts = (state = initialState, action) => {
  switch (action.type) {
    case PERMISSIONS_TAB:
      if (state.currentTab !== action.payload) {
        return {
          ...state,
          checked: {},
        };
      }
      break;
    case RESET_ALL_FILTERS:
      if (action.payload) {
        return {
          ...state,
          checked: {},
          count: 0,
        };
      }
      break;
    case RETAILER_PRODUCTS:
      return {
        ...state,
        data: action.payload,
      };
    case RETAILER_PRODUCTS_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case RETAILER_PRODUCTS_COUNT:
      return {
        ...state,
        count: +action.payload,
      };
    case RETAILER_PRODUCTS_SEARCH:
      return {
        ...state,
        search: action.payload,
        offset: 0,
      };
    case RETAILER_PRODUCTS_ORDER:
      return {
        ...state,
        order: action.payload.order,
        orderBy: action.payload.orderBy,
        offset: 0,
      };
    case RETAILER_PRODUCTS_CHECK:
      return {
        ...state,
        checked: {
          ...state.checked,
          [action.payload.model]: action.payload.variants,
        },
      };
    case RETAILER_PRODUCTS_UNCHECK:
      const newChecked = { ...state.checked };
      delete newChecked[action.payload.model];

      return {
        ...state,
        checked: newChecked,
      };
    case RETAILER_PRODUCTS_CHECK_ALL_ON_PAGE:
      return {
        ...state,
        checked: {
          ...state.checked,
          ...action.payload,
        },
      };
    case RETAILER_PRODUCTS_UNCHECK_ALL:
      return {
        ...state,
        checked: {},
      };
    case RETAILER_PRODUCTS_APPROVE:
      return {
        ...state,
        approved: uniq([...state.approved, ...action.payload]),
        unapproved: state.unapproved.filter((x) => !action.payload.includes(x)),
      };
    case RETAILER_PRODUCTS_UNAPPROVE:
      return {
        ...state,
        approved: state.approved.filter((x) => !action.payload.includes(x)),
        unapproved: uniq([...state.unapproved, ...action.payload]),
      };
    case RETAILER_PRODUCTS_DETAILS:
      return {
        ...state,
        productDetails: action.payload,
      };
    case RETAILER_PRODUCTS_ALL:
      const checkedAll = {};
      action.payload.forEach((product) => {
        checkedAll[product.model] = product.variants;
      });
      return {
        ...state,
        checked: checkedAll,
      };
    case RETAILER_PRODUCTS_APPROVED:
      return {
        ...state,
        approved: action.payload,
        unapproved: [],
      };
    case RETAILER_PRODUCTS_MODAL_OPEN:
      return {
        ...state,
        modal: true,
      };
    case RETAILER_PRODUCTS_MODAL_CLOSE:
      return {
        ...state,
        modal: false,
      };
    case RETAILER_PRODUCTS_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case RETAILER_PRODUCTS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case RETAILER_PRODUCTS_LOADING_PRODUCTS:
      return {
        ...state,
        isLoadingProducts: action.payload,
      };

    case PRODUCT_FILTERS_SET_FILTERS:
      return {
        ...state,
        offset: 0,
      };
    default:
      break;
  }

  return state;
};

export default retailerProducts;
